import classNames from "classnames";
import {
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownTrigger,
} from "@/components";
import { DotsVerticalIcon } from "@vetty/icons";
import styles from "./AccountListItem.module.scss";
import {
  formatAccountTimestamp,
  getAccountRoleMeta,
  getAccountSubscriptionMeta,
} from "../../_constants/accounts.const";
import { Account } from "../../_types/accounts.types";

type AccountListItemProps = {
  account: Account;
  onOpenDetails: () => void;
  onEdit: () => void;
  onRequestDelete: () => void;
  actionsDisabled: boolean;
  deleteDisabled: boolean;
};

export const AccountListItem = ({
  account,
  onOpenDetails,
  onEdit,
  onRequestDelete,
  actionsDisabled,
  deleteDisabled,
}: AccountListItemProps) => {
  const roleMeta = getAccountRoleMeta(account.role);
  const subscriptionMeta = getAccountSubscriptionMeta(account.hasSubscription);
  const fullName = [account.firstName, account.lastName].filter(Boolean).join(" ").trim();

  return (
    <div className={styles["comp"]}>
      <button type="button" className={styles["comp__main"]} onClick={onOpenDetails}>
        <div className={styles["comp__person"]}>
          <div className={styles["comp__sender"]}>
            <div className={styles["comp__name"]}>{fullName || "—"}</div>
            <div className={styles["comp__email"]}>{account.email}</div>
          </div>
        </div>

        <div className={styles["comp__role"]}>
          <span
            className={classNames(
              styles["comp__badge"],
              styles[`comp__badge--${roleMeta.variant}`]
            )}
          >
            {roleMeta.label}
          </span>
        </div>

        <div className={styles["comp__subscription"]}>
          <span
            className={classNames(
              styles["comp__badge"],
              styles[`comp__badge--${subscriptionMeta.variant}`]
            )}
          >
            {subscriptionMeta.label}
          </span>
        </div>

        <time className={styles["comp__created-at"]}>
          {formatAccountTimestamp(account.createdAt)}
        </time>

        <time className={styles["comp__last-activity"]}>
          {formatAccountTimestamp(account.lastActivityAt)}
        </time>
      </button>

      <div className={styles["comp__actions"]}>
        <Dropdown>
          <DropdownTrigger className={styles["comp__dropdownTrigger"]}>
            <button
              type="button"
              className={styles["comp__menuTrigger"]}
              aria-label="Account actions"
              aria-haspopup="menu"
              disabled={actionsDisabled}
            >
              <DotsVerticalIcon style={{ width: 20, height: 20 }} aria-hidden />
            </button>
          </DropdownTrigger>
          <DropdownContent width={180} lockBodyScroll={false}>
            <DropdownItem
              id={`${account.id}-edit`}
              selectable={false}
              className={styles["comp__menuItem"]}
              disabled={actionsDisabled}
              onClick={() => onEdit()}
            >
              Edit
            </DropdownItem>
            <DropdownItem
              id={`${account.id}-delete`}
              selectable={false}
              className={classNames(styles["comp__menuItem"], styles["comp__menuItem--danger"])}
              disabled={actionsDisabled || deleteDisabled}
              onClick={() => onRequestDelete()}
            >
              Delete
            </DropdownItem>
          </DropdownContent>
        </Dropdown>
      </div>
    </div>
  );
};
